<script lang="ts">
	import { Button, Text } from '@Shelly/shelly-design-system/index';
	import DeviceViewSelectionModal from 'src/components/Sidepanel/DeviceViewSelectionModal.svelte';
	import { isNoRelayPlug } from 'src/helpers/interface_helpers';
	import { format } from 'svelte-i18n';
	import { isActiveHomeShared } from 'src/helpers/houses/homes_helpers';
	import { homes } from 'src/stores/account/home';
	import SharedHomeOwnerManagedAlert from 'src/components/SharedHome/SharedHomeOwnerManagedAlert.svelte';

	export let device;

	if (isNoRelayPlug(device.type)) {
		device.category = 'power_meter';
	}

	let showModal = false;

	$: isSharedHomeActive = isActiveHomeShared($homes.list);
</script>

{#if isSharedHomeActive}
	<SharedHomeOwnerManagedAlert class="mb-m" context="change_view" />
{:else}
	<Text styleType="body-small" class="mb-m">
		{$format('text_change_view', {
			default:
				'You can switch between different device views to change the appearance and layout of the default device tab.',
		})}
	</Text>
{/if}

<Button size="m" width="full" disabled={isSharedHomeActive} on:click={() => (showModal = true)}>
	{$format('button_change_view', { default: 'Change view' })}
</Button>

{#if !isSharedHomeActive}
	<DeviceViewSelectionModal bind:showModal {device} />
{/if}
